import { MODULE_TYPE } from '@utils/constants';

export const REQUEST_KEY = 'request_security_validation';
export const VERIFY_KEY = 'verify_security_validation';
export const CF_RULES = 'cf_turnstile_rules';
export const MAX_ATTEMPT = 'maxLoginAttempt';
export const TURNSTILE_MODULES = [
    MODULE_TYPE.LOGIN,
    MODULE_TYPE.REGISTRATION,
    MODULE_TYPE.RESET_PASSWORD,
    MODULE_TYPE.EXTERNAL_REGISTRATION,
    MODULE_TYPE.AFF_RETRIEVE_USERNAMES,
];
